//Libs
import * as _ from 'lodash';
//Constants
import * as ACTIONS from './actionTypes';
//Types
import { ListingKeywordsData, LMkeywords } from './types';
import { ActionGetLMKeywordsAPISuccess, ActionPostLMKeywordsAPISuccess } from './actions';
//Types

export interface EngineKeywordState {
  keywordsData?: ListingKeywordsData;
}

const defaultState: EngineKeywordState = {
  keywordsData: undefined
};

type GetLMKeywordsAction = ActionGetLMKeywordsAPISuccess | ActionPostLMKeywordsAPISuccess;

function keywordsReducer(state: EngineKeywordState = defaultState, action: GetLMKeywordsAction): EngineKeywordState {
  switch (action.type) {
    case ACTIONS.GET_LMKEYWORDS_API_SUCCESS:
      {
        const {
          keywordsData
        } = (action as ActionGetLMKeywordsAPISuccess).lmkeywords
        return {
          ...state,
          keywordsData: keywordsData
        }
      }
    case ACTIONS.POST_LMKEYWORDS_API_SUCCESS:
      {
        const { keywordsData } = (action as ActionPostLMKeywordsAPISuccess).lmkeywords
        return {
          ...state,
          keywordsData: keywordsData ? { ...keywordsData } : undefined
        }
      }
    default: {
      return {
        ...state
      }
    }
  }

}


export default keywordsReducer